import { useState, useEffect } from "react";
import { numFormatter } from "../utils/formatterUtils";
import Decimal from 'decimal.js';

const BestOptionsChart = ({ bestOptions, indexValues, rowIndex, rateIndex, segments, onClick }) => {

    const [displayBuffer,setDisplayBuffer] = useState(false);
    const [displayFloor,setDisplayFloor] = useState(false);
    const [displayDownsideParticipation,setDisplayDownsideParticipation] = useState(false);
    const [displayDual,setDisplayDual] = useState(false);
    const [displayCap,setDisplayCap] = useState(false);
    const [displayStep,setDisplayStep] = useState(false);
    const [displayYield,setDisplayYield] = useState(false);
    const [displayYieldInterest,setDisplayYieldInterest] = useState(false);
    const [displayParticipation2,setDisplayParticipation2] = useState(false);
    const [displayTier,setDisplayTier] = useState(false);
    const [displayMilestone,setDisplayMilestone] = useState(false);
    const [displayBoost,setDisplayBoost] = useState(false);
    const [displaySpread,setDisplaySpread] = useState(false);
    const [displayProtection,setDisplayProtection] = useState(false);
    const [displayAnnualFeeRate,setDisplayAnnualFeeRate] = useState(false);

    const formatRate = (rate) => {
        return (rate !== 'Uncapped' && rate !== '-' ? `${rate}%` : rate);
    };

    const getLink = (bestOption) => {
        return segments.find(segment => (
            segment.Provider === bestOption.option.Provider && segment.SegmentType === bestOption.option.SegmentType
        ))?.Link;
    };

    useEffect(() => {
        setDisplayBuffer(bestOptions.some(bestOption => bestOption.option.Buffer));
        setDisplayFloor(bestOptions.some(bestOption => bestOption.option.Floor));
        setDisplayDownsideParticipation(bestOptions.some(bestOption => bestOption.option.DownsideParticipation));
        setDisplayDual(bestOptions.some(bestOption => bestOption.option.Dual));
        setDisplayCap(bestOptions.some(bestOption => bestOption.option.Cap));
        setDisplayStep(bestOptions.some(bestOption => bestOption.option.Step));
        setDisplayYield(bestOptions.some(bestOption => bestOption.option.Yield));
        setDisplayYieldInterest(bestOptions.some(bestOption => bestOption.option.YieldInterest));
        setDisplayParticipation2(bestOptions.some(bestOption => bestOption.option.Participation2));
        setDisplayTier(bestOptions.some(bestOption => bestOption.option.Tier));
        setDisplayMilestone(bestOptions.some(bestOption => bestOption.option.Milestone));
        setDisplayBoost(bestOptions.some(bestOption => bestOption.option.Boost));
        setDisplaySpread(bestOptions.some(bestOption => bestOption.option.Spread));
        setDisplayProtection(bestOptions.some(bestOption => bestOption.option.Protection));
        setDisplayAnnualFeeRate(bestOptions.some(bestOption => bestOption.option.AnnualFeeRate));
      },[bestOptions]);
    
    return (
        <table className="highlight centered responsive-table">
            <thead>
                <tr>
                    <th>#</th>
                    <th>Provider</th>
                    <th>Segment Type</th>
                    <th>Index</th>
                    <th>Minimum Investment</th>
                    {displayBuffer && <th>Buffer</th>}
                    {displayFloor && <th>Floor</th>}
                    {displayDownsideParticipation && <th>Downside Participation</th>}
                    {displayDual && <th>Dual</th>}
                    {displayCap && <th>Cap</th>}
                    {displayStep && <th>Step</th>}
                    {displayYield && <th>Yield</th>}
                    {displayYieldInterest && <th>Yield Interest</th>}
                    <th>Participation</th>
                    {displayParticipation2 && <th>Participation 2</th>}
                    {displayTier && <th>Tier</th>}
                    {displayMilestone && <th>Milestone</th>}
                    {displayBoost && <th>Boost</th>}
                    {displaySpread && <th>Spread</th>}
                    {displayProtection && <th>Protection</th>}
                    {displayAnnualFeeRate && <th>Annual Fee Rate</th>}
                    <th>Index Performance</th>
                    <th>Segment Performance</th>
                    <th>Performance Delta</th>
                </tr>
            </thead>

            <tbody>
                {bestOptions.map((bestOption,index) => (
                    <tr key={index+1} className={rowIndex === index ? "blue lighten-5" : ""} onClick={() => onClick(index)} style={{ cursor: 'pointer' }}>
                        <td>{index+1}</td>
                        <td>{bestOption.option.Provider}</td>
                        <td>{getLink(bestOption) ? (<a href={getLink(bestOption)} target="_blank" rel="noopener noreferrer" >{bestOption.option.SegmentType}</a>)
                            : (bestOption.option.SegmentType)}</td>
                        <td>{bestOption.option.Index}</td>
                        <td>{numFormatter(new Decimal(bestOption.option.Minimum.replace(',','')),'$',false)}</td>
                        {displayBuffer && <td>{formatRate(bestOption.option.Buffer || '-')}</td>}
                        {displayFloor && <td>{formatRate(bestOption.option.Floor || '-')}</td>}
                        {displayDownsideParticipation && <td>{formatRate(bestOption.option.DownsideParticipation || '-')}</td>}
                        {displayDual && <td>{formatRate(bestOption.option.Dual || '-')}</td>}
                        {displayCap && <td>{formatRate(bestOption.option.Cap || '-')}</td>}
                        {displayStep && <td>{formatRate(bestOption.option.Step || '-')}</td>}
                        {displayYield && <td>{formatRate(bestOption.option.Yield || '-')}</td>}
                        {displayYieldInterest && <td>{formatRate(bestOption.option.YieldInterest || '-')}</td>}
                        <td>{bestOption.option.Participation || 100}%</td>
                        {displayParticipation2 && <td>{formatRate(bestOption.option.Participation2 || '-')}</td>}
                        {displayTier && <td>{formatRate(bestOption.option.Tier || '-')}</td>}
                        {displayMilestone && <td>{formatRate(bestOption.option.Milestone || '-')}</td>}
                        {displayBoost && <td>{formatRate(bestOption.option.Boost || '-')}</td>}
                        {displaySpread && <td>{formatRate(bestOption.option.Spread || '-')}</td>}
                        {displayProtection && <td>{formatRate(bestOption.option.Protection || '-')}</td>}
                        {displayAnnualFeeRate && <td>{formatRate(bestOption.option.AnnualFeeRate || '-')}</td>}
                        <td>{numFormatter(indexValues[rateIndex].finalRate,'%',true)} / {numFormatter(indexValues[rateIndex].finalAmount,'$')}</td>
                        <td>{numFormatter(bestOption.rateValues[rateIndex].finalRate,'%',true)} / {numFormatter(bestOption.rateValues[rateIndex].finalAmount,'$')}</td>
                        <td>{numFormatter(bestOption.rateValues[rateIndex].finalRate.sub(indexValues[rateIndex].finalRate),'%',true)} / 
                            {numFormatter(bestOption.rateValues[rateIndex].finalAmount.sub(indexValues[rateIndex].finalAmount),'$',true)}</td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
};

export default BestOptionsChart;